import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";

const STATUS = { due: ["Dovuta", "bg-amber-100 text-amber-800"], overdue: ["Scaduta · bloccato", "bg-red-100 text-red-800"], paid: ["Pagata", "bg-emerald-100 text-emerald-800"], compensated: ["Compensata", "bg-sky-100 text-sky-800"], waived: ["Condonata", "bg-slate-200 text-slate-700"] };

export default function AdminCommissionDues() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/commission-dues").then(({ data }) => setData(data)).catch(() => setData({ items: [], totals: {} }));
  useEffect(() => { load(); }, []);
  const act = async (id, action) => {
    try { await api.post(`/admin/commission-dues/${id}/${action}`); toast.success(action === "waive" ? "Condonata" : "Segnata pagata"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (!data) return <div className="text-sm text-slate-500">Caricamento...</div>;
  const fmt = (d) => d ? new Date(d).toLocaleDateString("it-IT") : "—";
  return (
    <div className="ga-card p-5" data-testid="admin-commission-dues">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="font-display text-lg font-bold text-slate-900">Commissioni su bonifico diretto</div>
        <div className="text-xs font-mono text-slate-600">Dovute € {(data.totals.due || 0).toFixed(2)} · Scadute € {(data.totals.overdue || 0).toFixed(2)}</div>
      </div>
      {data.items.length === 0 ? <div className="mt-4 text-sm text-slate-500">Nessuna commissione registrata.</div> : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="text-slate-500 font-mono uppercase tracking-widest text-left">
              <tr><th className="py-2 pr-3">Fornitore</th><th className="py-2 pr-3">Ordine</th><th className="py-2 pr-3">Lordo</th><th className="py-2 pr-3">Commissione</th><th className="py-2 pr-3">Scadenza</th><th className="py-2 pr-3">Stato</th><th className="py-2"></th></tr>
            </thead>
            <tbody>
              {data.items.map(i => {
                const [label, cls] = STATUS[i.status] || [i.status, ""];
                const open = ["due", "overdue"].includes(i.status);
                return (
                  <tr key={i.id} className="border-t border-slate-100" data-testid={`admin-due-${i.id}`}>
                    <td className="py-2 pr-3"><div className="font-semibold text-slate-900">{i.supplier?.name}</div><div className="text-slate-500">{i.supplier?.email}</div></td>
                    <td className="py-2 pr-3">{i.order_title}</td>
                    <td className="py-2 pr-3 font-mono">€ {i.gross_amount.toFixed(2)}</td>
                    <td className="py-2 pr-3 font-mono">€ {i.remaining.toFixed(2)}{i.remaining !== i.amount && <span className="text-slate-400"> / {i.amount.toFixed(2)}</span>}</td>
                    <td className="py-2 pr-3">{fmt(i.due_at)}</td>
                    <td className="py-2 pr-3"><span className={`rounded-full px-2 py-0.5 font-semibold ${cls}`}>{label}</span></td>
                    <td className="py-2 text-right whitespace-nowrap">
                      {open && <>
                        <Button size="sm" variant="outline" className="rounded-full mr-1" onClick={() => act(i.id, "mark-paid")} data-testid={`admin-due-paid-${i.id}`}>Segna pagata</Button>
                        <Button size="sm" variant="ghost" className="rounded-full" onClick={() => act(i.id, "waive")} data-testid={`admin-due-waive-${i.id}`}>Condona</Button>
                      </>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
